module.exports = __webpack_public_path__ + "img/jumbotron-politics-explained-2.4485cb68.jpg";